import { addModal } from 'weblite-web-modal-viewer'
import { InviteLink } from '@weblite/ts-action/hall'
// component
import { ActiveLinkMenu } from './active-link-menu'

const COMPONENT_ID = 'activeLinkMenu'

interface Prop {
  link: InviteLink
}

export const showActiveLinkMenu = (props: Prop, preventBackClick = false) =>
  addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: ActiveLinkMenu },
}
